const { REACT_APP_ENV } = process.env;
export const ocrTypes = {
    hv: 'HV OCR',
    googlejs: 'GoogleJS OCR',
    google: 'Google OCR',
    azure: 'Azure OCR',
    azurev2: 'AzureV2 OCR',
    ssp: 'SSP OCR',
    aws: 'AWS OCR'
}

export const regions = REACT_APP_ENV === "prod" ? {
    "ind": "Mumbai",
    "sgp": "Singapore",
    "usa": "N. Virginia",
    "idn": "Jakarta",
    "zaf": "Cape Town",
} : {
    "stg": "STAGING",
    "dev": "DEV",
}

export const defaultRegion = REACT_APP_ENV === 'prod' ? 'ind' : 'stg';

export const getSelectedRegion = () => {
    try {
        const urlRegion = new URLSearchParams(window.location.search).get('region');
        if (urlRegion && regions[urlRegion]) {
            localStorage.setItem('REGION', urlRegion);
            return urlRegion;
        }
        const localStorageRegion = localStorage.getItem('REGION');
        if (localStorageRegion && regions[localStorageRegion]) return localStorageRegion;
        localStorage.setItem('REGION', defaultRegion);
        return defaultRegion;
    }
    catch {
        return defaultRegion;
    }
};

export const navPath = (path) => path;
export const navSearch = () => '';

export const getCurrentInferenceDomain = () => {
    const selectedRegion = getSelectedRegion();
    return `${selectedRegion}-turing.hyperverge.co`;
}